// START IMPORTS
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';

import {
  CardContainer,
  CardHeaderRow,
  ReportTitle,
  SeeFullReportCTA,
  ViewReportButton,
} from '../../components';

import {
  VehicleDetailsSection,
  VehicleRecordsSection,
  VehicleValueSection,
} from './sections';

import type { VehicleReportData } from 'components/DeepSearch/types';
// END IMPORTS

interface VehicleReportPreviewCardProps {
  data: VehicleReportData;
  onViewReport?: () => void;
}

// START RENDER
export const VehicleReportPreviewCard = ({
  data,
  onViewReport,
}: VehicleReportPreviewCardProps) => {
  return (
    <CardContainer>
      <CardHeaderRow sx={{ mb: 1.5 }}>
        <DirectionsCarIcon sx={{ fontSize: 24 }} />
        <ReportTitle m={0}>{data.searchQuery || 'Vehicle Report'}</ReportTitle>
        {onViewReport && <ViewReportButton onClick={onViewReport} />}
      </CardHeaderRow>

      <VehicleValueSection data={data} />
      <VehicleDetailsSection data={data} />
      <VehicleRecordsSection data={data} />
      {onViewReport && <SeeFullReportCTA onClick={onViewReport} />}
    </CardContainer>
  );
};
// END RENDER
